import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { login } from "../../store/user/actions";
import { selectToken } from "../../store/user/selectors";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import "./style.css";

export default function SignUp() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const navigate = useNavigate();

  useEffect(() => {
    if (token !== null) {
      navigate("/dashboard");
    }
  }, [token, navigate]);

  function submitForm(event) {
    console.log("hi");
    event.preventDefault();

    dispatch(login(email, password));

    setEmail("");
    setPassword("");
  }

  return (
    <>
      <Container className="flex">
        <Container>
          <Form
            as={Col}
            md={{ span: 6, offset: 3 }}
            className="mt-5 form-padding"
          >
            <h1 className="mt-5 mb-5">Login</h1>
            <Form.Group controlId="formBasicEmail" className="form-padding">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                type="email"
                placeholder="Enter email"
                required
              />
            </Form.Group>

            <Form.Group controlId="formBasicPassword" className="form-padding">
              <Form.Label>Password</Form.Label>
              <Form.Control
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                type="password"
                placeholder="Password"
                required
              />
            </Form.Group>
            <Form.Group className="mt-5 form-padding">
              <Button
                style={{ backgroundColor: "#0d5c63", border: "0px" }}
                variant="primary"
                type="submit"
                onClick={submitForm}
              >
                Log in
              </Button>
            </Form.Group>

            <Link
              to="/signup"
              style={{ textAlign: "center", color: "#0d5c63" }}
              className="form-padding"
            >
              Click here to sign up
            </Link>
          </Form>
        </Container>
      </Container>
    </>
  );
}
